import React, { Component } from 'react';
import { Input } from 'antd';
import ErrorBoundary from '../../ErrorBoundary';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from '../../actions';

const { withGoogleMap, withScriptjs } = require('react-google-maps');
const {
  StandaloneSearchBox,
} = require('react-google-maps/lib/components/places/StandaloneSearchBox');

const API_KEY = process.env.REACT_APP_G_MAP_API_KEY;

export const G_API_URL = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&&v=3.exp&libraries=places`;

const Searchbox = withScriptjs(
  withGoogleMap((props) => (
    <>
      <StandaloneSearchBox
        ref={props.onSearchBoxMounted}
        onPlacesChanged={props.onPlacesChanged}
      >
        <div style={{ position: 'relative' }}>
          <div>
            <input
              type="text"
              placeholder={props.placeholder}
              name={props.name}
              value={props.state.input}
              onChange={props.onChange}
              style={{
                fontSize: '17px',
                width: '100%',
                height: '53px',
                borderLeft: `1px solid ${props.primaryColor}`,
                borderRight: '0px',
                borderTop: '0px',
                borderBottom: '0px',
                borderRadius: '0px',
                padding:
                  props.name === 'origin'
                    ? '0px 10px 0px 35px'
                    : '0px 10px 0px 48px',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                outline: '0px',
                boxShadow: 'none',
              }}
            />
            <span
              style={{
                position: 'absolute',
                display: 'inline-block',
                top: 0,
                left: 0,
                height: '36px',
                width: '18px',
                padding:
                  props.name === 'origin'
                    ? '12px 8.5px 8.5px 8.5px'
                    : '12px 8.5px 8.5px 21.5px',
                fontSize: '24px',
                color: props.secondaryColor,
                fontStyle: 'normal',
              }}
            >
              {props.name === 'origin' ? 'A' : 'B'}
            </span>
          </div>
        </div>
      </StandaloneSearchBox>
      {!props.isFormSubmitSuccess && (
        <ol>
          {props.state.places.map(
            ({ place_id, name, formatted_address, geometry: { location } }) => (
              <li key={place_id}>
                {props.onSetValue(
                  props.name,
                  place_id,
                  name,
                  formatted_address,
                  location
                )}
              </li>
            )
          )}
        </ol>
      )}
    </>
  ))
);

/**
 * @component
 * @category Search Page
 * @subcategory Search bar
 * @name Dropdown
 * @description It's the google map dropdown appears upon typing into origin of shipment input and destination of shipment input fields.
 * <br> <br>
 * **Example**
 * ```js
 *  <Dropdown name="origin" placeholder="ORIGIN OF SHIPMENT" />
 * ```
 */
class Dropdown extends Component {
  searchBox = null;
  place_id = '';
  name = '';
  formatted_address = '';
  location = '';

  state = {
    input: '',
    places: [],
  };

  componentDidMount = () => {
    if (this.props.name === 'origin') {
      this.setState({ input: this.props.queryParams.from });
    } else {
      this.setState({ input: this.props.queryParams.to });
    }
  };

  componentWillReceiveProps = (nextProps) => {
    if (this.state.input !== nextProps) {
      if (this.props.name === 'origin') {
        this.setState({ input: nextProps.queryParams.from });
      } else {
        this.setState({ input: nextProps.queryParams.to });
      }
      return true;
    }
    return false;
  };

  /**
   * @description It creates a ref to google map StandaloneSearchBox component
   * (It's in the module `react-google-maps`)
   * <br> <br>
   * **onSearchBoxMounted(ref) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | ref           | React Ref     | React ref |
   * <br> <br>
   * Returns: Type: void
   */
  onSearchBoxMounted = (ref) => {
    this.searchBox = ref;
  };

  /**
   * @description It is invoked when a user selects a place from google places dropdown
   * <br> <br>
   * **onPlacesChanged() -> {void}**
   * <br><br>
   * Returns: Type: void
   */
  onPlacesChanged = () => {
    const places = this.searchBox.getPlaces();
    this.setState({
      places,
    });
  };

  /**
   * @description It is invoked when a user selects a place from google places dropdown.
   * It is also used to update the query params.
   * <br> <br>
   * **onSetValue(origin_of_shipment,place_id,name,formatted_address,location) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | origin_of_shipment  | string  | name of the input e.g. `origin`  |
   * | place_id      | string        | selected google place id e.g. `ChIJAVsJfFRHJz9NdmhbnQ`  |
   * | name          | string        | name of selected google place e.g. `Delhi Airport`  |
   * | formatted_address | string    | formatted address of selected google place e.g. `New Delhi, Delhi 110037, India`  |
   * | location      | object        | location of selected google place e.g. `{lat: Function, lng: Function}`  |
   * <br> <br>
   * Returns: Type: void
   */
  onSetValue = (
    origin_of_shipment,
    place_id,
    name,
    formatted_address,
    location
  ) => {
    this.place_id = place_id;
    this.name = name;
    this.formatted_address = formatted_address;
    this.location = location;

    this.setState({ input: formatted_address, places: [] });

    // console.log(
    //   "origin_of_shipment: " + origin_of_shipment,
    //   "place_id: ",
    //   this.place_id,
    //   " name:",
    //   this.name,
    //   " formatted_address:",
    //   this.formatted_address,
    //   " lat:",
    //   this.location.lat(),
    //   " lng:",
    //   this.location.lng()
    // );

    this.setAddress(origin_of_shipment, formatted_address);
  };

  /**
   * @description It updates the query params.
   * <br> <br>
   * **setAddress(origin_of_shipment, input_value) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | origin_of_shipment  | string  | name of the input e.g. `origin`  |
   * | input_value   | string        | formatted address of selected google place e.g. `New Delhi, Delhi 110037, India`  |
   * <br> <br>
   * Returns: Type: void
   */
  setAddress = (origin_of_shipment, input_value) => {
    if (this.props.isFormSubmitSuccess) {
      return; //form is used, don't allow to edit the fields
    }
    if (origin_of_shipment === 'origin') {
      this.props.setQueryParams({
        ...this.props.queryParams,
        from: input_value,
      });
    } else {
      this.props.setQueryParams({
        ...this.props.queryParams,
        to: input_value,
      });
    }
    // console.log(
    //   "origin_of_shipment: ",
    //   origin_of_shipment,
    //   "input_value: ",
    //   input_value
    // );
  };

  /**
   * @description It is invoked when user types into origin/destination input fields
   * <br> <br>
   * **onChange(e) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | e             | Event         | Mouse Event i.e onchange event  |
   * <br> <br>
   * Returns: Type: void
   */

  onChange = (e) => {
    e.preventDefault();
    // this.setState({ input: e.target.value });
    this.setAddress(this.props.name, e.target.value);
  };

  render() {
    return (
      //prettier-ignore
      <ErrorBoundary>
      <Searchbox
          googleMapURL={G_API_URL}
          onPlacesChanged={this.onPlacesChanged}
          onSearchBoxMounted={this.onSearchBoxMounted}
          state={this.state}
          onChange={this.onChange}
          onSetValue={this.onSetValue}
          placeholder={this.props.placeholder}
          name={this.props.name}
          loadingElement={<div style={{ height: `100%`, borderRadius: `0px`  }} />}
          containerElement={<div style={{ height: `100%`, borderRadius:`0px` }} />}
          mapElement={<div style={{ height: `0%`, borderRadius: `0px` }} />}
          isFormSubmitSuccess={this.props.isFormSubmitSuccess}
          primaryColor={this.props.primaryColor}
          secondaryColor={this.props.secondaryColor}
        />
       </ErrorBoundary>
    );
  }
}

Dropdown.propTypes = {
  /**
   * query params from redux store
   */
  queryParams: PropTypes.object,

  /**
   * Primary Color of the web app
   */
  primaryColor: PropTypes.string,

  /**
   * Secondary Color of the web app
   */
  secondaryColor: PropTypes.string,

  /**
   * Whether Form mode is used
   */
  isFormSubmitSuccess: PropTypes.bool,

  /**
   * name of input field
   */
  name: PropTypes.string.isRequired,

  /**
   * placeholder for the input field
   */
  placeholder: PropTypes.string.isRequired,
};

const mapStateToProps = ({ route, code_config, form }) => {
  return {
    queryParams: route.queryParams,
    primaryColor: code_config.primaryColor,
    secondaryColor: code_config.secondaryColor,
    // showOpenMap: code_config.showOpenMap,
    isFormSubmitSuccess: form.isFormSubmitSuccess,
  };
};

export default connect(mapStateToProps, actions)(Dropdown);
